import appActions from 'App/duck/actions'
import { appTracking } from 'helpers/tracking'

import publishedActions from './publishedActions'

const handleOnStateChange = (prevState, nextState, action): void => {
  if (window.hm && window.hm.eventBus && publishedActions.includes(action.type)) {
    window.hm.eventBus.emit(action.type, action)
  }

  if (
    action.type === appActions.trackEvent.getType() ||
    action.type === appActions.trackESalesEvent.getType()
  ) {
    appTracking(action)
  }
}

export default handleOnStateChange
